import React, { useState } from 'react';
import { Box, Typography, Paper, Collapse, IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import VideocamIcon from '@mui/icons-material/Videocam';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { getFormattedFileTypes } from '../../Utils/fileValidation';

const FileUploadNote = ({ 
  allowedTypes = ['document'], 
  maxSizeInMB = 10, 
  maxFiles = 1,
  initialExpanded = true
}) => {
  const [isExpanded, setIsExpanded] = useState(initialExpanded);
  const supportedFormats = getFormattedFileTypes(allowedTypes);

  const getTypeIcon = (type) => {
    switch(type) {
      case 'document':
        return <DescriptionIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom', color: '#1976d2' }} />;
      case 'image':
        return <ImageIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom', color: '#2e7d32' }} />;
      case 'video':
        return <VideocamIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom', color: '#ed6c02' }} />;
      default:
        return null;
    }
  };

  return (
    <Paper 
      elevation={0}
      sx={{ 
        backgroundColor: '#f8f9fa',
        padding: '12px 16px',
        borderRadius: '8px',
        marginBottom: '16px',
        border: '1px solid #e0e0e0'
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        '&:hover': { opacity: 0.8 }
      }}
      onClick={() => setIsExpanded(!isExpanded)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoIcon sx={{ 
            marginRight: '12px', 
            color: '#1976d2', 
            fontSize: '20px'
          }} />
          <Typography 
            variant="subtitle2" 
            sx={{ 
              color: '#1976d2',
              fontWeight: 600
            }}
          >
            File Upload Requirements
          </Typography>
        </Box>
        <IconButton 
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <Box sx={{ color: '#555', mt: 1, ml: 4 }}>
          <Typography 
            component="div" 
            variant="body2" 
            sx={{ 
              mb: 1,
              '& .MuiBox-root': {
                mb: 0.5
              }
            }}
          >
            <Box sx={{ fontWeight: 500, mb: 1 }}>1. Supported formats:</Box>
            {Object.entries(supportedFormats).map(([type, extensions]) => (
              <Box 
                key={type} 
                sx={{ 
                  ml: 2,
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '0.875rem'
                }}
              >
                {getTypeIcon(type)}
                <span style={{ fontWeight: 500 }}>{type.charAt(0).toUpperCase() + type.slice(1)}:</span>
                <span style={{ marginLeft: '4px' }}>{extensions.join(', ')}</span>
              </Box>
            ))}
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500
            }}
          >
            2. Maximum file size: <span style={{ marginLeft: '4px', fontWeight: 400 }}>{maxSizeInMB}MB</span>
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              display: 'flex',
              alignItems: 'center',
              fontWeight: 500
            }}
          >
            3. Maximum number of files:  <span style={{ marginLeft: '4px', fontWeight: 400 }}>{maxFiles}</span>
          </Typography>
        </Box>
      </Collapse>
    </Paper>
  );
};

export default FileUploadNote; 